import { render } from "./PlatSystemService.vue?vue&type=template&id=390e9dd2&scoped=true"
import script from "./PlatSystemService.vue?vue&type=script&lang=js"
export * from "./PlatSystemService.vue?vue&type=script&lang=js"

import "./PlatSystemService.vue?vue&type=style&index=0&id=390e9dd2&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-390e9dd2"]])

export default __exports__